import "../../../chunk-PKUHTIDK.js";
const hasOwnProp = (obj, key) => Object.prototype.hasOwnProperty.call(obj, key);
var hasOwnProp_default = hasOwnProp;
export {
  hasOwnProp_default as default
};
